import { LINK_MODAL_ID } from "./constants";
import { openLinkModal } from "./open-link-modal";
const toggleLinkModal = ({
  initialValue,
  modalService,
  onSave,
  onSaveMultiple,
  onUnlink,
  referenceElement,
  placement,
  onClickOutside,
  returnFocusToEditor,
  enabledLinkTypes
}) => modalService.isModalOpen(LINK_MODAL_ID) ? modalService.closeModal(LINK_MODAL_ID) : openLinkModal({
  initialValue,
  modalService,
  onSaveMultiple,
  onSave,
  onUnlink,
  referenceElement,
  placement,
  onClickOutside,
  returnFocusToEditor,
  enabledLinkTypes
});
export {
  toggleLinkModal
};
//# sourceMappingURL=toggle-link-modal.js.map
